var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "h-100", attrs: { id: "login" } }, [
    _c(
      "div",
      { staticClass: "container-fluid h-100" },
      [
        _c(
          "b-row",
          { staticClass: "h-100" },
          [
            _c(
              "b-col",
              { attrs: { id: "bg-side", md: "12" } },
              [
                _c("LanguageSwitch"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "loginCard" },
                  [
                    _c("div", {
                      staticClass: "position-relative",
                      attrs: { id: "logo" },
                    }),
                    _vm._v(" "),
                    _c(
                      "b-form",
                      {
                        staticClass:
                          "d-flex login-form flex-column justify-content-center w-50 mx-auto",
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.submit.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "email-input-group",
                              label: _vm.$t("message.yourEmail"),
                              "label-for": "email-input",
                            },
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|email",
                                  expression: "'required|email'",
                                },
                              ],
                              staticClass: "form-mail",
                              attrs: {
                                id: "email-input",
                                name: "email",
                                placeholder: "",
                                trim: "",
                                type: "email",
                              },
                              model: {
                                value: _vm.email,
                                callback: function ($$v) {
                                  _vm.email = $$v
                                },
                                expression: "email",
                              },
                            }),
                            _vm._v(" "),
                            _vm.isSubmit
                              ? _c(
                                  "span",
                                  { staticClass: "text-danger mt-3" },
                                  [_vm._v(_vm._s(_vm.errors.first("email")))]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "mt-4 login-btn",
                            attrs: {
                              disabled: _vm.loading,
                              type: "submit",
                              variant: "primary",
                            },
                          },
                          [
                            _vm.loading
                              ? _c(
                                  "span",
                                  [
                                    _c("b-spinner", {
                                      attrs: { small: "", type: "grow" },
                                    }),
                                  ],
                                  1
                                )
                              : _c("span", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t("message.sendFastLink")) +
                                      "\n                            "
                                  ),
                                ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("a-divider", { staticClass: "text-light" }, [
                          _vm._v(_vm._s(_vm.$t("message.or"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-center flex-column",
                          },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "mt-4 login-btn-extra",
                                attrs: { type: "button", variant: "secondary" },
                                on: {
                                  click: function () {
                                    return _vm.$router.push("login")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t("message.loginWithPassword")
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }